import { render, staticRenderFns } from "./ProjectBudgetHistory.vue?vue&type=template&id=457b457c"
import script from "./ProjectBudgetHistory.vue?vue&type=script&lang=js"
export * from "./ProjectBudgetHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports